import React from 'react';
import { HeaderContainer as StyledHeaderContainer } from './style';
import Header from '../../../components/HeaderV2/Header';

const HeaderContainer: React.FC = () => {
  return (
    <StyledHeaderContainer>
      <Header />
    </StyledHeaderContainer>
  );
};

export default HeaderContainer;
